import React from "react";
import Banner from "../../../../components/Banner";
import "../../../../assets/styles/career.scss";
import SubjectCards from "./SubjectCards";
import BottomBar from "../../../../components/BottomBar";
import { Bell } from "react-feather";
import { Link } from "react-router-dom";

import { Col, Container, Button, Row } from "reactstrap";

const DataScienctist = () => {
  const handleClick = () => {
    console.log("payment button click");
  };
  return (
    <React.Fragment>
      <Banner
        title="데이터 사이언티스트(Data Scientist) 가 되고싶다면?"
        bg="ds_banner.jpg"
      />
      <Container className="subject_container">
        <Row mb={3}>
          <Col md={6} sm={12}>
            <h2>데이터 사이언티스트란?</h2>
            <p>
              데이터 사이언티스트는 데이터를 관리하고 분석하여 비즈니스 문제를
              해결하기 위한 다양한 기술 및 도메인 기반 기술을 필요로 하는
              직업입니다. 일부 수학자, 일부 비즈니스 분석가 및 일부 컴퓨터
              과학자가 포함됩니다.
            </p>
          </Col>
          <Col md={6} sm={12}>
            <img
              src={require("../../../../assets/img/data_scientist_explain.jpg")}
              className="horizontal"
              alt="ucas_official"
            />
          </Col>
        </Row>
        <hr className="mt-4 mb-4" />

        <div className="compulsory-subjects">
          <Row className="mb-3">
            <Col md={8}>
              <h3 className="heading section-title">수강 과목 </h3>
            </Col>
          </Row>
          <Row>
            <Col md={3} className="mb-4">
              <SubjectCards title="Maths" img="maths.png" />
            </Col>
            <Col md={3}>
              <SubjectCards title="Further Maths" img="further_maths.png" />
            </Col>
            <Col md={3}>
              <SubjectCards
                title="Computer Science"
                img="computer_science.png"
              />
            </Col>
            <Col md={3} className="mb-4">
              <SubjectCards title="Economics" img="card4.png" />
            </Col>
          </Row>
        </div>
      </Container>
      <BottomBar>
        <Row>
          <Col md={8} sm={12}>
            <div className="d-inline-block">
              <Bell style={{ position: "relative", bottom: "10" }} />
            </div>
            <div className="d-inline-block pl-2">
              <p style={{ fontWeight: "700" }}>
                EARLY BIRD <span style={{ fontWeight: "900" }}>20%</span> 특별
                할인 이벤트!
              </p>
              <p style={{ fontSize: "0.9rem" }}>
                8월 24일 전에 신청하시면 할인 혜택을 받으실수 있습니다.
              </p>
            </div>
          </Col>
          <Col md={4} sm={12}>
            <Link to="/payment/premium_course">
              <Button
                color="danger"
                style={{ width: "100%" }}
                onClick={handleClick}
              >
                수강 신청하기
              </Button>
            </Link>
          </Col>
        </Row>
      </BottomBar>
    </React.Fragment>
  );
};

export default DataScienctist;
